import * as React from 'react';
import {
  TextareaAutosize,
  TextareaAutosizeProps,
} from '@material-ui/core';
import styled from 'styled-components';

const TextArea = ({
  error,
  inputRef,
  ...props
}: ExtendedTextareaAutosizeProps) => (
  // eslint-disable-next-line react/jsx-props-no-spreading
  <Textarea error={error} inputRef={inputRef} {...props} />
);

const Textarea = styled(({ error, inputRef, ...props }) => (
  // eslint-disable-next-line react/jsx-props-no-spreading
  <TextareaAutosize ref={inputRef} {...props} />
))<{ error?: boolean }>`
  width: 100%;
  border: 1px solid
    ${({ error }) =>
      error ? 'var(--danger-500)' : 'var(--neutral-300)'};
  border-radius: var(--radius-md);
  background: var(--neutral-0);
  color: var(--neutral-800);
  font-size: var(--fs-base);
  font-family: inherit;
  line-height: var(--lh-normal);
  padding: 10px 12px;
  transition:
    border-color var(--motion-fast) var(--ease-standard),
    box-shadow var(--motion-fast) var(--ease-standard);

  &::placeholder {
    color: var(--neutral-400);
  }

  &:hover {
    border-color: ${({ error }) =>
      error ? 'var(--danger-600)' : 'var(--neutral-400)'};
  }

  &:focus {
    outline: none;
    border-color: ${({ error }) =>
      error ? 'var(--danger-500)' : 'var(--primary-600)'};
    box-shadow: ${({ error }) =>
      error ? 'var(--shadow-focus-danger)' : 'var(--shadow-focus)'};
  }

  &:disabled {
    background: var(--neutral-100);
    color: var(--neutral-500);
    cursor: not-allowed;
  }
`;

interface ExtendedTextareaAutosizeProps
  extends TextareaAutosizeProps {
  error: boolean;
  inputRef?: React.RefObject<HTMLInputElement>;
}

export default TextArea;
